import React, { useId } from 'react';
import classnames from 'classnames';

export type CriticalCaseIconProps = React.SVGProps<SVGSVGElement>;

/** Figma (136_598): 16×16 outline circle + “!” — stroke #FB2C36 */
export function CriticalCaseIcon({
  className,
  width = 16,
  height = 16,
  ...props
}: Readonly<CriticalCaseIconProps>) {
  const clipId = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={classnames('shrink-0', className)}
      aria-hidden
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668Z"
          stroke="#FB2C36"
          strokeWidth={1.33333}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5.33337V8.00004"
          stroke="#FB2C36"
          strokeWidth={1.33333}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10.6666H8.00667"
          stroke="#FB2C36"
          strokeWidth={1.33333}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
